// E³-Survey Web結果画面の定数・固定文言（2026-09 feature/e3viewCreate）
// ------------------------------------------------------------------
// 文言はプロトタイプ v3.0（02_エンゲージメント_script.js / 03_エンゲージメント_data.js）から転記。
// 中項目の定義・重要性は「Engagement Survey_企画設計.xlsx」、タイプは同「タイプ一覧」が正本。
// 集計値そのものはサーバー（/api/results/30010）が返す。ここには表示用の定義だけを置く。

export const AREAS = ['会社', '上司', '職場', '職務'];
export const EMP_OF = { 会社: 'A', 上司: 'G', 職場: 'M', 職務: 'S' };
export const FACTS_OF = {
  会社: ['B', 'C', 'D', 'E', 'F'],
  上司: ['H', 'I', 'J', 'K', 'L'],
  職場: ['N', 'O', 'P', 'Q', 'R'],
  職務: ['T', 'U', 'V', 'W', 'X'],
};
export const AREA_LABEL = { 会社: '会社共感', 上司: '上司共感', 職場: '職場共感', 職務: '職務共感' };

// 中項目 A〜X（key・名称・領域・共感/事実・定義・重要性）
export const CATS = [
  {
    key: "A",
    name: "共感（会社）",
    area: "会社",
    kind: "共感",
    def: "従業員が経営理念・ビジョンに深く賛同し、会社への強い帰属意識と誇りを持っている状態",
    why: "自身の仕事が社会貢献に繋がっている実感を持ち、会社の成長に直接貢献したいという意欲から生まれる"
  },
  {
    key: "B",
    name: "経営理念（発信）",
    area: "会社",
    kind: "事実",
    def: "経営陣が会社の存在意義や使命、目指すべきビジョンと事業・組織運営における優先事項を明確に発信し、自らその理念を体現していること",
    why: "業務内容と会社の目指す理念実現の繋がりを理解・納得することで、会社全体への共感度が高まる"
  },
  {
    key: "C",
    name: "経営基盤",
    area: "会社",
    kind: "事実",
    def: "商品・サービスが顧客から高い評価を得られ、安定的な顧客基盤と健全な財務状態があること。また、激変する業界・市場動向に素早い対応ができること",
    why: "安定的な生活と成長を得られることで会社への信頼を感じ共感度を高める"
  },
  {
    key: "D",
    name: "勤務環境",
    area: "会社",
    kind: "事実",
    def: "設備の安全性やアクセスの良さ、就業時間やコミュニケーションの柔軟性といった働く環境が良いこと",
    why: "安心して働くことができる環境は、個々人が能力を最大限に発揮でき、パフォーマンスが高まることで、会社への共感も高める"
  },
  {
    key: "E",
    name: "人的資本",
    area: "会社",
    kind: "事実",
    def: "多様で優れた人材の採用、教育・研修機会の提供、適材適所への配置によって従業員の持つスキルや知識、ノウハウ、資質などを成長させること",
    why: "自社に属することで得られた機会を活用して自身の成長を実感することで会社への共感が高まる"
  },
  {
    key: "F",
    name: "人事制度（構築）",
    area: "会社",
    kind: "事実",
    def: "会社の事業を推進する上で必要、かつ個々人が自分の意思を反映させた目標を設定し、公平な評価によって、適切な報酬が提供される人事制度であること",
    why: "公平で透明な人事制度は、特に報酬に関わるため、会社への信頼と共感を高める"
  },
  {
    key: "G",
    name: "共感（上司）",
    area: "上司",
    kind: "共感",
    def: "従業員が上司の掲げる部門ビジョンや仕事で実現したいこと、大切にしている価値観に賛同し、部門目標達成への貢献意欲を持っている状態",
    why: "この上司とずっと働き続けたい、一緒に新しいことに挑戦したいと思えるような動機付けによって生まれる"
  },
  {
    key: "H",
    name: "部門方針",
    area: "上司",
    kind: "事実",
    def: "全社の理念やビジョン、経営戦略、目標を踏まえた上で、職場方針を明確に発信し、職場メンバーと対話しながら理解を促進させること",
    why: "メンバーが職場方針に基づく一貫した行動を取り、成果に繋がる仕組みをつくることで上司への共感を高める"
  },
  {
    key: "I",
    name: "問題解決",
    area: "上司",
    kind: "事実",
    def: "職場で発生した（これから発生するであろう）問題をそのままにせず、早期に特定してメンバーと解決に向けた行動を起こすこと",
    why: "問題解決に取り組む姿勢を示し、メンバーと意見交換しながら解決策を意思決定し、さらに上位層への提言や他部門との連携を図ることで上司への共感を高める"
  },
  {
    key: "J",
    name: "協働促進",
    area: "上司",
    kind: "事実",
    def: "相互理解を深めるコミュニケーション機会や情報共有の仕組みをつくることで、メンバー同士の共同作業や業務連携を促進すること",
    why: "協働する中でメンバー同士の信頼関係が深まり、職場全体の成果や生産性が高まることで、上司への共感も高まる"
  },
  {
    key: "K",
    name: "人材育成",
    area: "上司",
    kind: "事実",
    def: "職場メンバーが成果を出して目標を達成してキャリアビジョンを実現するために、知識・能力開発を目的とした教育を行うこと",
    why: "メンバーが目標達成による充足感、教育機会による成長実感を持つことで上司への共感を高める"
  },
  {
    key: "L",
    name: "人事評価（運用）",
    area: "上司",
    kind: "事実",
    def: "会社全体で定められた人事評価制度にもとづいて、メンバーの目標設定や中間面談、期末の評価・フィードバック面談などを運用すること",
    why: "会社からの期待と個人の意思を反映した目標設定、成果とプロセスを正確に把握した評価を行うことで、上司への共感を高める"
  },
  {
    key: "M",
    name: "共感（職場）",
    area: "職場",
    kind: "共感",
    def: "従業員が自分の所属する職場全体で掲げられたビジョンに賛同し、職場メンバーの一員であることに誇りを持っている状態",
    why: "職場の問題解決に当事者意識を持ち、目標達成への貢献実感、そしてメンバーから学び成長した実感を持つことで生まれる"
  },
  {
    key: "N",
    name: "経営理念（共有）",
    area: "職場",
    kind: "事実",
    def: "会社の経営理念と職場での具体的な行動について考え、自分の仕事がどんな人の役に立っているのか職場メンバーと話し合って共通認識を持つこと",
    why: "メンバー全員が自分の仕事に社会的意義を感じ、職場方針に納得して行動できるようになることで、職場全体の一体感と共感が高まる"
  },
  {
    key: "O",
    name: "職場風土",
    area: "職場",
    kind: "事実",
    def: "多様性が尊重され、挑戦的な活動が奨励される職場の雰囲気であり、メンバー同士の人間関係が良好であること",
    why: "多様性を認め合った対話や挑戦的な活動のように自由さがありながら、規律や倫理を遵守されるようなメリハリのある風土が職場全体への共感を高める"
  },
  {
    key: "P",
    name: "情報共有",
    area: "職場",
    kind: "事実",
    def: "会社・職場の歴史が受け継がれ、顧客対応や社内連携の成功・失敗事例について、メンバー全員が情報の重要性を理解して、即時に共有していること",
    why: "情報共有により、メンバー全員が仕事において効果的な議論や意思決定ができ、職場全体への共感が高まる"
  },
  {
    key: "Q",
    name: "協働推進",
    area: "職場",
    kind: "事実",
    def: "職場メンバーが仕事に高い専門性と責任感を持ち、お互いに目標を共有し、尊重し合いながらも助け合うことで、チームワークを促進する取り組みのこと",
    why: "効率性の向上や新たなアイデアの創出につながることで、職場全体への共感を高める"
  },
  {
    key: "R",
    name: "変革活動",
    area: "職場",
    kind: "事実",
    def: "市場環境や顧客ニーズの変化に素早く対応するために、既存の仕組みに固執することなく、新しいアイデアや方法を検討・導入する取り組みのこと",
    why: "メンバーが変革活動を進める中で自分の意見を出し、参画感を持つことで職場全体への共感を高める"
  },
  {
    key: "S",
    name: "共感（職務）",
    area: "職務",
    kind: "共感",
    def: "従業員が自分の仕事に社会的意義や重要性を感じ、熱意を持って取り組んでいる状態",
    why: "自分の能力を最大限に活かして取り組み、仕事にやりがいを感じ、成長実感や達成感を得ることを通じて生まれる"
  },
  {
    key: "T",
    name: "経営理念（実践）",
    area: "職務",
    kind: "事実",
    def: "会社の経営理念が何を目指しているのかを理解し、職場目標や自分の担当業務・役割と関連付けて行動すること",
    why: "自身の仕事が社会や顧客に対して価値を提供し、経営理念実現に貢献できているという実感を持つことで、自らの職務への共感が高まる"
  },
  {
    key: "U",
    name: "貢献行動",
    area: "職務",
    kind: "事実",
    def: "知識・能力や役割を最大限に活用して、組織の成果に貢献する行動のこと",
    why: "他メンバーへのサポートや職場の問題提起など、自ら主体的に行動を起こすことで、貢献実感が生まれて、自らの職務への共感も高まる"
  },
  {
    key: "V",
    name: "成長実感",
    area: "職務",
    kind: "事実",
    def: "仕事上で知識や能力の向上、挑戦意欲や目標達成の実感、役割や責任の拡大を経験すること",
    why: "成長実感を感じることで、自分に自信が持てて、次の挑戦に繋がったり、仕事に取り組むモチベーションを高め、自らの職務への共感が高まる"
  },
  {
    key: "W",
    name: "自己決定",
    area: "職務",
    kind: "事実",
    def: "業務内容や職場内での役割について、上司や職場メンバーの決定に従うだけではなく、自分自身でも意思決定すること",
    why: "意思決定するために、自ら仕事の全体像や重要性に関する情報を収集することで、成果を出すことに繋がり、自らの職務への共感を高める"
  },
  {
    key: "X",
    name: "人事評価（納得）",
    area: "職務",
    kind: "事実",
    def: "仕事に取り組む際、上司やメンバーと合意した目標を設定し、目標達成（成果）と行動に対する評価に理解・納得すること",
    why: "目標に自分の意見や意思を反映し、評価やフィードバックを成長の糧であると捉えることで、自らの職務への共感を高める"
  }
];
export const CAT_BY = Object.fromEntries(CATS.map((c) => [c.key, c]));
export const FACT_CATS = CATS.filter((c) => c.kind === '事実');
// 設問番号（q = 回答番地 + 1）→ 中項目
// 中項目 → 設問番号（q）の一覧
export const CAT_QS = {
    A: [26, 27, 28, 29, 30], B: [1, 6, 11, 16, 21], C: [2, 7, 12, 17, 22], D: [3, 8, 13, 18, 23],
    E: [4, 9, 14, 19, 24], F: [5, 10, 15, 20, 25], G: [57, 58, 59, 60, 61], H: [32, 37, 42, 47, 52],
    I: [33, 38, 43, 48, 53], J: [34, 39, 44, 49, 54], K: [35, 40, 45, 50, 55], L: [36, 41, 46, 51, 56],
    M: [88, 89, 90, 91, 92], N: [63, 68, 73, 78, 83], O: [64, 69, 74, 79, 84], P: [65, 70, 75, 80, 85],
    Q: [66, 71, 76, 81, 86], R: [67, 72, 77, 82, 87], S: [119, 120, 121, 122, 123], T: [94, 95, 96, 97, 98],
    U: [99, 100, 101, 102, 103], V: [104, 105, 106, 107, 108], W: [109, 110, 111, 112, 113], X: [114, 115, 116, 117, 118],
};
export const CAT_OF_Q = (() => {
  const idx = CAT_QS;
  const m = {};
  Object.entries(idx).forEach(([k, qs]) => qs.forEach((q) => { m[q] = k; }));
  return m;
})();

export const CORR_TH = 0.7; // 優先課題の影響度しきい値
export const CHG_TH = 2.0; // 変化しきい値 ±2.0pt
// ランクは A〜F の6段階。F の下限は 0（G＝0 点は Web では使わない・2026-10-05 依頼側）。PDF は従来どおり。
export const RANK_RANGE = { A: '84〜100', B: '68〜83', C: '51〜67', D: '34〜50', E: '18〜33', F: '0〜17' };
// 推測される組織の状態（2026-10-05 依頼側の文言・改修希望 E3-02。G は使わないため G の文言は入れない）
export const RANK_STATE = {
  A: 'お互いに信頼し合って同じ方向を向いている',
  B: '課題や弱みもメンバー同士で率直に対話できる',
  C: '大きな不満はないが踏み込んだ対話は少ない',
  D: 'どこか不信感がありお互いへの関心が薄れている',
  E: '不満が表に出ていて改善を諦めかけている',
  F: '不満と諦めが広がって協力し合うことが難しい',
};
// 上位指標の定義文（帳票 p3 準拠）
export const DEF = {
  total:'従業員が組織に対して自発的な貢献意欲を持ち、主体的に仕事に取り組めている状態。会社に対する愛着心や仕事への情熱、社員と会社の双方向の関係性や結びつきの度合いを指す',
  org:'従業員が組織の事業内容や文化、価値観を深く理解して自分との重なりを見つけ、経営層／上司／職場メンバーと共に働くことに誇りと愛着を持っている状態',
  job:'従業員が自分の仕事に社会的意義や重要性を感じ、熱意を持って取り組んでいる状態',
};
// エンゲージメントタイプ（名前・説明文はプロトタイプのもの。★タイプ名は確認中）
// 個人PDF と同じ 65 基準・4 タイプ（2026-09-30 依頼側確認。サーバー src/e3Web/e3Type.js と揃える）
export const TYPE_TH = 65;
export const TYPE_ORDER = ['いきいき活躍', 'つながり重視', 'じっくり集中', 'ひとやすみ充電'];
// タイプごとの色。個人PDF（makeReport30010_P.js の分布図のタイプ名）と同じ色にそろえる（2026-10-02）。
//   いきいき活躍＝天職・協働／つながり重視＝受動・従属／じっくり集中＝自律・独立／ひとやすみ充電＝受動・妨害
export const TYPE_COLOR = {
  いきいき活躍: '#F5BF9D',
  つながり重視: '#A5B9E1',
  じっくり集中: '#BEDEAB',
  ひとやすみ充電: '#9F9A9A',
};

export const TYPE_INFO = {
  'つながり重視':{cond:'組織：65より高い／職務：65以下',
    def:'個人の業務における達成感よりも、職場の人間関係や組織の和を重んじている状態',
    desc:'会社の理念への共感や職場メンバーへの信頼感は厚く、組織への帰属意識は高い。一方で、現在担当している日々の業務内容に対しては、意義や主体性をやや見出しにくくなっている。',
    kw:['調和','協調性','サポート','安心感','帰属意識']},
  'いきいき活躍':{cond:'組織：65より高い／職務：65より高い',
    def:'会社やチームへの信頼と、自身の仕事へのやりがいの両方が高く満たされている状態',
    desc:'組織のビジョンや仲間に共感し、周囲と良好な関係を築きながら、自身の業務においても主体的に価値を生み出している。個人の成長と組織の成長が重なり合うサイクルに入っている。',
    kw:['共創','充実感','主体性','シナジー','本領発揮']},
  'じっくり集中':{cond:'組織：65以下／職務：65より高い',
    def:'組織全体への意識よりも、自身の役割や目の前の仕事にエネルギーを集中させている状態',
    desc:'会社やチームとの関わりにおいては少し距離を感じているが、自身の業務そのものに対しては高い意欲と集中力を持って取り組んでいる。',
    kw:['専心','自律','没頭','専門性','マイペース']},
  'ひとやすみ充電':{cond:'組織：65以下／職務：65以下',
    def:'組織との関わりにおいても、日々の仕事においても、心身のエネルギーが一時的に低下している状態',
    desc:'会社への信頼感や仕事へのモチベーションがともに下がっており、現状の働き方に対して何らかの負担や迷いを感じている。',
    kw:['内省','充電','見つめ直し','休息','現状整理']},
};

export const grade = (t) =>
  t == null || isNaN(t) ? null : t >= 84 ? 'A' : t >= 68 ? 'B' : t >= 51 ? 'C' : t >= 34 ? 'D' : t >= 18 ? 'E' : 'F';
export const rkCls = (v) => (v == null || isNaN(v) ? '' : `rk-${grade(v).toLowerCase()}`);
export const fx1 = (v) => (v == null || isNaN(v) ? '–' : Number(v).toFixed(1));
export const avg = (xs) => {
  const v = xs.filter((x) => x != null && !isNaN(x));
  return v.length ? v.reduce((a, b) => a + b, 0) / v.length : null;
};
export const r1 = (v) => (v == null ? null : Math.round(v * 10) / 10);

// 推移グラフ・経年比較表の見出し用の短いシーズン名。
// 「2025年度 …」のように年度で始まる名前は年度だけ、それ以外は開始年月（YYYY/MM）
export const seasonShort = (name, startDate) => {
  const m = String(name || '').match(/^\s*(\d{4}年度)/);
  if (m) return m[1];
  const d = startDate ? new Date(startDate) : null;
  if (d && !isNaN(d.getTime())) return `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, '0')}`;
  return name || '';
};


// ------------------------------------------------------------------
// 改修希望 v1.1（2026-10-13・E3-08〜10）で足した表示用の定義。プロトタイプ v3.2（02_エンゲージメント_script.js）から転記。
// 小項目の名前・短い定義の正本は 01_企画「Engagement Survey_企画設計.xlsx」（短い定義は 2026-10-12 決定）。

// 共感の小項目 20 問の名前（「|」はグラフで折り返してよい位置。表・プルダウンでは取り除く）
export const EMP_ITEM_LABEL = {
  26:'経営|ビジョン|への賛同', 27:'会社への|誇り', 28:'会社への|所属感', 29:'社会貢献|への意欲', 30:'会社の成長|への貢献',
  57:'部門・部署|ビジョン|への賛同', 58:'メンバー|への|動機付け', 59:'上司との|協働意欲', 60:'上司との|挑戦意欲', 61:'部門・部署|目標達成|への貢献',
  88:'職場|ビジョン|への賛同', 89:'職場|メンバー|としての|誇り', 90:'職場課題|への|当事者意識', 91:'職場からの|学習意欲', 92:'目標達成|への貢献',
  119:'キャリア|ビジョン', 120:'職務への|魅力', 121:'職務による|成長実感', 122:'職務の意義', 123:'職務での|達成感',
};
// 事実の小項目 100 問の名前（同上）
export const FACT_ITEM_NAME = {
  1:'経営|理念の|発信', 2:'財務の|健全性', 3:'職場|環境の|快適さ', 4:'優秀な|人材の|採用', 5:'目標|への|意思|反映',
  6:'経営|ビジョン|の発信', 7:'顧客|基盤の|安定性', 8:'コミュ|ニケー|ション|の促進', 9:'人材の|多様性', 10:'評価|基準の|明確性',
  11:'経営|環境|変化の|発信', 12:'商品・|サービス|への|評価', 13:'就業|時間の|自由度', 14:'人材|育成|への|投資', 15:'給与の|妥当性',
  16:'経営|方針の|発信', 17:'技術・|ノウハウ|の|優位性', 18:'休暇の|取り|やすさ', 19:'人材の|活用', 20:'部署|間の|公平性',
  21:'経営|理念の|実践', 22:'環境|変化への|対応力', 23:'勤務|ロケー|ション|の選択', 24:'学習の|機会', 25:'昇進|昇格|基準の|明確性',
  32:'経営|理念の|伝達', 33:'問題の|発見', 34:'職場|コミュ|ニケー|ション|の促進', 35:'意見の|尊重', 36:'目標|設定の|適切さ',
  37:'部門|環境|変化の|共有', 38:'問題|解決|への|姿勢', 39:'業務|進捗の|共有|促進', 40:'強みの|活用', 41:'部下の|目標|達成|支援',
  42:'部門|方針の|展開', 43:'解決策|の提示', 44:'協働の|重要性', 45:'能力|開発', 46:'部下|への|フィード|バック',
  47:'市場・|顧客情報|の共有', 48:'意思|決定の|迅速さ', 49:'社内|情報の|共有', 50:'キャリア|の支援', 51:'評価の|適切さ',
  52:'部門|方針の|実践', 53:'上位者|への|提言', 54:'他部門|の|巻き|込み', 55:'部下の|コンディ|ション|把握', 56:'評価の|活用',
  63:'経営|理念の|共有', 64:'挑戦的|活動の|奨励', 65:'知識・|情報の|共有', 66:'個人|目標の|共有', 67:'変化の|認知',
  68:'経営|理念の|実践', 69:'組織の|風通し', 70:'情報|共有の|仕組み|活用', 71:'職務|への|責任感', 72:'変化の|共有',
  73:'部門|戦略の|共有', 74:'多様性|の受容', 75:'情報の|重要性|認識', 76:'職場|メンバー|の協働', 77:'変化の|受け|止め方',
  78:'部門|方針に|沿った|行動', 79:'メンバー|同士の|協力・|連携', 80:'会社の|歴史や|経緯の|共有', 81:'職場|メンバー|の能力', 82:'環境|変化への|対応',
  83:'部門|戦略の|変革|対応', 84:'コンプラ|イアンス|の遵守', 85:'成功・|失敗事例|の共有', 86:'個人の|尊重', 87:'顧客|ニーズ|への|対応',
  94:'社会的|倫理観に|基づく|行動', 95:'部門|方針の|主体的|理解', 96:'経営|理念に|基づく|判断', 97:'行動|指針に|沿った|行動', 98:'経営|理念の|定着|活動',
  99:'上司|への|提言', 100:'上司の|活動|支援', 101:'社会|への|貢献', 102:'顧客|への|貢献', 103:'関係者|への|貢献',
  104:'能力の|向上', 105:'気持ちの|切り|替え', 106:'職務|への|集中', 107:'経験の|振り|返り', 108:'経験の|活用',
  109:'能力の|発揮', 110:'職務|全体の|把握', 111:'自律性|の発揮', 112:'職務の|重要性|認識', 113:'成果の|把握',
  114:'合意|目標の|納得', 115:'人事|評価の|納得', 116:'フィード|バックの|適切さ', 117:'業務量|の|適切さ', 118:'業務|難易度|の|適切さ',
};
export const itemName = (q) => (EMP_ITEM_LABEL[q] || FACT_ITEM_NAME[q] || `設問${q}`).replace(/\|/g, '');
// 事実の中項目の定義（短い版）。オーバービューの分布図のポップアップ・要因分析の一覧に出す
export const CAT_DEF_SHORT = {
  B:'経営陣が経営理念やビジョンを分かりやすく発信しているか', C:'将来も安心して働ける安定した経営基盤があるか',
  D:'働きやすい勤務環境が整っているか', E:'会社が人材の採用や育成に力を入れているか', F:'公平で納得できる人事制度が整っているか',
  H:'上司が部門の方針を分かりやすく示しているか', I:'上司が職場の問題に向き合い、解決に取り組んでいるか',
  J:'上司がメンバー同士の協力を後押ししているか', K:'上司がメンバーの成長を支援しているか', L:'上司が目標設定や評価を適切に行っているか',
  N:'職場で経営理念や仕事の意義が共有されているか', O:'互いを尊重し、自由に意見を言い合える職場か', P:'職場で必要な情報や知識が共有されているか',
  Q:'職場メンバーが互いに助け合って仕事を進めているか', R:'職場メンバーが変化を前向きに捉えて対応しているか',
  T:'経営理念を日々の判断や行動に活かせているか', U:'自分の仕事を通じて周囲や顧客に貢献できているか', V:'仕事を通じて自分の成長を実感できているか',
  W:'仕事の進め方を自分で考えて決められているか', X:'自分の目標や評価に納得できているか',
};

// 要因分析の 4 区分（スコア＝中項目のスコア、影響度＝同じ領域の共感度との相関）。並びは 改善項目 → 強化項目 → 観察項目 → 維持項目
//   改善項目＝スコアが平均以上・影響度 0.7 以上（これまでの「優先課題」と同じ条件）／強化項目＝平均未満・0.7 以上
//   観察項目＝平均未満・0.7 未満／維持項目＝平均以上・0.7 未満
export const FQ = {
  pri: { name: '改善項目', act: 'いまの取り組み内容やメッセージを改善する', cond: 'スコアが平均以上・影響度0.7以上' },
  build: { name: '強化項目', act: '新しい取り組みをはじめる／強化する', cond: 'スコアが平均未満・影響度0.7以上' },
  watch: { name: '観察項目', act: '変化や受け止め感をよく観察する', cond: 'スコアが平均未満・影響度0.7未満' },
  keep: { name: '維持項目', act: 'いまの取り組み水準を保つ', cond: 'スコアが平均以上・影響度0.7未満' },
};
export const FQ_ORDER = ['pri', 'build', 'watch', 'keep'];
export const fqOf = (s, r, fAvg) =>
  s == null || r == null ? null : r >= CORR_TH ? (s >= fAvg ? 'pri' : 'build') : s >= fAvg ? 'keep' : 'watch';

// 折れ線用のタイプの色（TYPE_COLOR と同じ色相で、白地の線として読める濃さ）
export const TYPE_LINE_COLOR = {
  いきいき活躍: '#EB8647',
  つながり重視: '#4D77CB',
  じっくり集中: '#6CB143',
  ひとやすみ充電: '#6E6969',
};

// 回答分布の横軸（1〜7 すべてに回答画面の選択肢の文言。\n は改行してよい位置）
export const DIST_CAPS = [
  '1 全く\nそう思わない',
  '2 そう思わない',
  '3 どちらかといえば\nそう思わない',
  '4 どちらとも\nいえない',
  '5 どちらかといえば\nそう思う',
  '6 そう思う',
  '7 非常に\nそう思う',
];
